// src/pages/ProductPanels.jsx
import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import "./Product.css";

// ✅ Dummies (use your existing assets)
import dashboardImg from "../assets/01.png";
import navapp from "../assets/02.png";
import oem from "../assets/03.png";


export default function ProductPanels({
  leftImage = dashboardImg,
  rightImage = navapp,
  rightImage2 = oem,
}) {
  const reduce = useReducedMotion();
  const ease = [0.2, 0.8, 0.2, 1];

  const reveal = {
    hidden: reduce
      ? { opacity: 1, y: 0, filter: "blur(0px)" }
      : { opacity: 0, y: 12, filter: "blur(6px)" },
    show: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.75, ease },
    },
  };

  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.06, delayChildren: 0.04 } },
  };

  return (
    <section className="pp" aria-label="Products">
      <motion.div
        className="pp__grid"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
      >
        {/* LEFT CARD */}
        <motion.article className="pp__card" variants={reveal}>
          <div className="pp__table">
            {/* Row 1 */}
            <div className="pp__r1">
              <div className="pp__kicker">For Site Owners</div>
            </div>

            {/* Row 2 */}
            <div className="pp__r2">
              <h2 className="pp__title">AI-POWERED TRAFFIC CONTROLLER — UTC</h2>
            </div>

            {/* Row 3 */}
            <div className="pp__r3">
              <p className="pp__lede">
                AI that orchestrates flow, reducing dwell time and optimising asset
                utilisation — in real time.
              </p>
            </div>

            {/* Row 4 */}
            <div className="pp__r4">
              <div className="pp__steps">
                <div className="pp__step">
                  <span className="pp__n">1</span>
                  <div className="pp__stepText">Analyse destinations &amp; priorities</div>
                </div>

                <div className="pp__step">
                  <span className="pp__n">2</span>
                  <div className="pp__stepText">
                    Signal clearance{" "}
                    <span className="pp__muted">— Wait · Stop · Proceed</span>
                  </div>
                </div>

                <div className="pp__step">
                  <span className="pp__n">3</span>
                  <div className="pp__stepText">Site rerouting for vehicles</div>
                </div>

                <div className="pp__step">
                  <span className="pp__icon" aria-hidden="true">
                    🤖
                  </span>
                  <div className="pp__stepText">Block traffic &amp; manual override</div>
                </div>
              </div>
            </div>

            {/* Row 5 (FULL BLEED) */}
            <div className="pp__r5">
              <img
                className="pp__img pp__img--contain"  // ✅ key: no crop
                src={leftImage}
                alt="UTC dashboard (illustrative)"
                loading="lazy"
              />
              <div className="pp__caption">Image: illustrative purpose only</div>
            </div>
          </div>
        </motion.article>

        {/* RIGHT CARD */}
        <motion.article className="pp__card" variants={reveal}>
          <div className="pp__table">
            {/* Row 1 */}
            <div className="pp__r1">
              <div className="pp__kicker">For Vehicle Manufacturers &amp; Drivers</div>
            </div>

            {/* Row 2 */}
            <div className="pp__r2">
              <h2 className="pp__title">AI-POWERED SITE NAVIGATION</h2>
            </div>

            {/* Row 3 */}
            <div className="pp__r3">
              <p className="pp__lede">
                Site-level instructions delivered to end-users to navigate with certainty —
                from gate to bay to charger.
              </p>
            </div>

            {/* Row 4 */}
            <div className="pp__r4">
              <div className="pp__steps">
                <div className="pp__step">
                  <span className="pp__n">1</span>
                  <div className="pp__stepText">Site rerouting for vehicles</div>
                </div>
              </div>

              <div className="pp__mid">
                <div className="pp__midLabel">Cars with Drivers</div>
                <div className="pp__midArrow" aria-hidden="true" />
                <div className="pp__midLabel">Self-driving cars</div>
              </div>

              <div className="pp__integration">
                <div className="pp__pill">SDK</div>
                <div className="pp__pill">API</div>
              </div>
            </div>

            {/* Row 5 (FULL BLEED split) */}
            <div className="pp__r5 pp__mediaSplit">
              {/* Cars with drivers */}
              <div className="pp__mediaCell">
                <img
                  className="pp__img"
                  src={rightImage}
                  alt="Navigation app for cars with drivers (dummy)"
                  loading="lazy"
                />
                <div className="pp__mediaLabel">
                  <div className="pp__mediaTitle">Cars with Drivers</div>
                  <div className="pp__mediaSub">Navigation app (illustrative)</div>
                </div>
              </div>

              {/* Self-driving */}
              <div className="pp__mediaCell">
                <img
                  className="pp__img"
                  src={rightImage2}
                  alt="Navigation for self-driving cars (dummy)"
                  loading="lazy"
                />
                <div className="pp__mediaLabel">
                  <div className="pp__mediaTitle">Self-driving Cars</div>
                  <div className="pp__mediaSub">Vehicle / OEM navigation (illustrative)</div>
                </div>
              </div>
            </div>
          </div>
        </motion.article>
      </motion.div>
    </section>
  );
}